import { config } from '../config';
import axios from 'axios'
import { post } from 'axios';

export const companyService = {

};
